var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MobileMenu"},[_c('div',{staticClass:"MobileMenu-header"},[_c('f2mLogo'),_c('FlagSelect',{attrs:{"country":_vm.$country,"data-cy":"select.flag"},on:{"flagSelected":_vm.flagSelected}})],1),_c('div',{staticClass:"MobileMenu-body"},[_c('MobileMenuBlock',{attrs:{"withSubMenu":true,"label":_vm.$t('personal-account.mobileMenu.myAccount'),"subMenu":[{
                           'label': _vm.$t('personal-account.mobileMenu.myProfile'),
                           'type': 'routeName',
                           'target': 'personalAccountProfile',
                           'iconClass': 'f2m-user'
                       },
                       {
                           'label': _vm.$t('personal-account.mobileMenu.yourInvoices'),
                           'type': 'routeName',
                           'target': 'personalAccountInvoices',
                           'iconClass': 'f2m-invoice'
                       },
                       {
                           'label': _vm.$t('personal-account.mobileMenu.coupons'),
                           'type': 'routeName',
                           'target': 'personalAccountCoupons',
                           'iconClass': 'f2m-rounded-percent'
                       },
                       {
                           'label': _vm.$t('personal-account.mobileMenu.bookings'),
                           'type': 'routeName',
                           'target': 'personalAccountBookings',
                           'iconClass': 'f2m-calendar'
                       },
                       {
                           'label': _vm.$t('personal-account.mobileMenu.yourCarOnDemand'),
                           'type': 'link',
                           'target': '/cod/contracts',
                           'iconClass': 'f2m-cod-car'
                       },
                       {
                           'label': _vm.$t('personal-account.mobileMenu.settings'),
                           'type': 'routeName',
                           'target': 'personalAccountSettings',
                           'iconClass': 'f2m-setting'
                       },
            ],"data-cy":"mobile-menu.my-account"},on:{"hideMenu":_vm.hideMenu}}),_c('MobileMenuBlock',{attrs:{"withSubMenu":false,"link":{
                'label': _vm.$t('personal-account.mobileMenu.carSharing'),
                'type': 'link',
                'target': _vm.getLink(_vm.$alternateLinksOthers['car-sharing'])
            },"data-cy":"mobile-menu.car-sharing"}}),_c('MobileMenuBlock',{attrs:{"withSubMenu":false,"link":{
                'label': _vm.$t('personal-account.mobileMenu.chargeMyCar'),
                'type': 'link',
                'target': _vm.getLink(_vm.$alternateLinksOthers['charge-my-car'])
            },"data-cy":"mobile-menu.charge-my-car"}}),_c('MobileMenuBlock',{attrs:{"withSubMenu":false,"link":{
                'label': _vm.$t('personal-account.mobileMenu.carRental'),
                'type': 'link',
                'target': _vm.getLink(_vm.$alternateLinksOthers['car-rental'])
            },"data-cy":"mobile-menu.car-rental"}}),_c('MobileMenuBlock',{attrs:{"withSubMenu":false,"link":{
                'label': _vm.$t('personal-account.mobileMenu.parkingLot'),
                'type': 'link',
                'target': _vm.getLink(_vm.$alternateLinksOthers['parking-lot'])
            },"data-cy":"mobile-menu.parking-lot"}}),_c('MobileMenuBlock',{attrs:{"withSubMenu":false,"link":{
                'label': _vm.$t('personal-account.mobileMenu.businessSolutions'),
                'type': 'link',
                'target': _vm.getLink(_vm.$alternateLinksOthers['business-solutions'])
            },"data-cy":"mobile-menu.business-solutions"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }